export const LINK_LIST = {
	result_url: { title: 'View Result', value: '{result_url}' },
	report_url: { title: 'View PDF', value: '{report_url}' },
	scorecard_url: { title: 'Scorecard Url', value: '{scorecard_url}' },
	email: { title: 'Email', value: 'mailto:{email}' },
	continue_questions_url: { title: 'Continue questions', value: '{continue_questions_url}' },
}

export const MERGE_TAG = Object.freeze({
	FIRST_NAME: 'first_name',
	LAST_NAME: 'last_name',
	EMAIL: 'email',
	CHANGE_EMAIL: 'change_email',
	SCORECARD_NAME: 'scorecard_name',
	SCORECARD_LOGO: 'logo',
	SECONDARY_LOGO: 'theme.secondary_logo',
	SQUARE_ICON: 'square_icon',
	SCORECARD_TAKEN_DATE: 'scorecard_taken_date',
	RESULT_KEY: 'result_key',
	OVERALL_SCORE_TIER: 'overall_score_tier',
	OVERALL_SCORE_PERCENT: 'overall_score',
	OVERALL_SCORE_ACTUAL: 'overall_score_actual',
	OVERALL_SCORE_OUT_OF_10: 'overall_score_out_of_10',
	OVERALL_SCORE_OUT_OF_10_ROUNDED: 'overall_score_out_of_10_rounded',
	REPORT_BUTTON: 'report_button',
	RESULT_BUTTON: 'result_button',
	SCORECARD_TAKEN_TIMESTAMP: 'scorecard_taken_timestamp',
})

export const MERGE_TAG_GROUP = Object.freeze({
	QUIZ_ANSWER: 'quiz_answer',
	LEAD_FORM_ANSWERS: 'lead_form_answers',
	SCORES: 'scores',
	PAGE_LINKS: 'page_links',
	LEAD: 'lead',
	SCORECARD: 'scorecard',
	LINKS: 'links',
	OVERALL: 'overall',
})

export const STYLES_FORMAT = [
	{
		title: 'Headings',
		items: [
			{ title: 'Heading 1', format: 'h1' },
			{ title: 'Heading 2', format: 'h2' },
			{ title: 'Heading 3', format: 'h3' },
			{ title: 'Heading 4', format: 'h4' },
			{ title: 'Heading 5', format: 'h5' },
			{ title: 'Heading 6', format: 'h6' },
		],
	},
	{
		title: 'Inline',
		items: [
			{ title: 'Bold', format: 'bold' },
			{ title: 'Italic', format: 'italic' },
			{ title: 'Underline', format: 'underline' },
			{ title: 'Strikethrough', format: 'strikethrough' },
			{ title: 'Superscript', format: 'superscript' },
			{ title: 'Subscript', format: 'subscript' },
		],
	},
	{
		title: 'Blocks',
		items: [
			{ title: 'Accent text', format: 'primary' },
			{ title: 'Paragraph', format: 'p' },
			{ title: 'Div', format: 'div' },
		],
	},
]

export const FONT_SIZES = [
	10,
	11,
	12,
	13,
	14,
	15,
	16,
	17,
	18,
	20,
	22,
	24,
	26,
	28,
	30,
	32,
	36,
	40,
	44,
	48,
	52,
	58,
	64,
	70,
	76,
	82,
	88,
	94,
	100,
]

export const LINE_HEIGHTS_FORMAT = [0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 2, 2.5, 3]

export const DESKTOP_TOOLBAR_HEIGHT = 87
export const MOBILE_TOOLBAR_HEIGHT = 126
export const TOOLBAR_OFFSET = 4
export const SMALL_MOBILE_TOOLBAR_HEIGHT = 40

export const EDITOR_VARIANT = Object.freeze({
	EMPHASIS: 'emphasis',
	SIMPLE: 'simple',
	SHORT: 'short',
	FULL: 'full',
	MOBILE: 'mobile',
})

export const DESKTOP_TOOLBAR_WIDTH = Object.freeze({
	[EDITOR_VARIANT.FULL]: 459,
	[EDITOR_VARIANT.SHORT]: 196,
	[EDITOR_VARIANT.EMPHASIS]: 130,
	[EDITOR_VARIANT.MOBILE]: 70,
})

export const MOBILE_TOOLBAR_WIDTH = Object.freeze({
	[EDITOR_VARIANT.FULL]: 308,
	[EDITOR_VARIANT.SHORT]: 196,
	[EDITOR_VARIANT.EMPHASIS]: 130,
	[EDITOR_VARIANT.MOBILE]: 70,
})

export const MERGE_TAGS = Object.freeze({
	[MERGE_TAG.OVERALL_SCORE_TIER]: {
		title: 'Tier',
		searchLabel: 'Scores | Overall | Tier',
		label: 'Overall | Tier',
		groups: [MERGE_TAG_GROUP.SCORES, MERGE_TAG_GROUP.OVERALL],
		order: 1,
	},
	[MERGE_TAG.OVERALL_SCORE_PERCENT]: {
		title: 'Percent',
		searchLabel: 'Scores | Overall | Percent',
		label: 'Overall | Percent',
		groups: [MERGE_TAG_GROUP.SCORES, MERGE_TAG_GROUP.OVERALL],
		order: 2,
	},
	[MERGE_TAG.OVERALL_SCORE_ACTUAL]: {
		title: 'Actual',
		searchLabel: 'Scores | Overall | Actual',
		label: 'Overall | Actual',
		groups: [MERGE_TAG_GROUP.SCORES, MERGE_TAG_GROUP.OVERALL],
		order: 3,
	},
	[MERGE_TAG.OVERALL_SCORE_OUT_OF_10]: {
		title: 'Out of 10',
		searchLabel: 'Scores | Overall | Out of 10',
		label: 'Overall | Out of 10',
		groups: [MERGE_TAG_GROUP.SCORES, MERGE_TAG_GROUP.OVERALL],
		order: 4,
	},
	[MERGE_TAG.OVERALL_SCORE_OUT_OF_10_ROUNDED]: {
		title: 'Out of 10 rounded',
		searchLabel: 'Scores | Overall | Out of 10 rounded',
		label: 'Overall | Out of 10 rounded',
		groups: [MERGE_TAG_GROUP.SCORES, MERGE_TAG_GROUP.OVERALL],
		order: 5,
	},
	[MERGE_TAG.FIRST_NAME]: {
		title: 'First name',
		searchLabel: 'Lead | First name',
		label: 'First name',
		groups: [MERGE_TAG_GROUP.LEAD],
		order: 1,
	},
	[MERGE_TAG.LAST_NAME]: {
		title: 'Last name',
		searchLabel: 'Lead | Last name',
		label: 'Last name',
		groups: [MERGE_TAG_GROUP.LEAD],
		order: 2,
	},
	[MERGE_TAG.EMAIL]: {
		title: 'Email',
		searchLabel: 'Lead | Email',
		label: 'Email',
		groups: [MERGE_TAG_GROUP.LEAD],
		order: 3,
	},
	[MERGE_TAG.SCORECARD_TAKEN_DATE]: {
		title: 'Completed date',
		searchLabel: 'Lead | Completed date',
		label: 'Completed date',
		groups: [MERGE_TAG_GROUP.LEAD],
		order: 4,
	},
	[MERGE_TAG.SCORECARD_TAKEN_TIMESTAMP]: {
		title: 'Completed timestamp',
		searchLabel: 'Lead | Completed timestamp',
		label: 'Lead | Completed timestamp',
		groups: [MERGE_TAG_GROUP.LEAD],
		order: 5,
	},
	[MERGE_TAG.RESULT_KEY]: {
		title: 'Lead ID',
		searchLabel: 'Lead | ID',
		label: 'Lead ID',
		groups: [MERGE_TAG_GROUP.LEAD],
		order: 6,
	},
	[MERGE_TAG.SCORECARD_NAME]: {
		title: 'Name',
		searchLabel: 'Scorecard | Name',
		label: 'Scorecard | Name',
		groups: [MERGE_TAG_GROUP.SCORECARD],
		order: 1,
	},
	[MERGE_TAG.SCORECARD_LOGO]: {
		title: 'Logo',
		searchLabel: 'Scorecard | Logo',
		label: 'Scorecard | Logo',
		groups: [MERGE_TAG_GROUP.SCORECARD],
		order: 2,
	},
	[MERGE_TAG.SECONDARY_LOGO]: {
		title: 'Secondary logo',
		searchLabel: 'Scorecard | Secondary logo',
		label: 'Scorecard | Secondary logo',
		groups: [MERGE_TAG_GROUP.SCORECARD],
		order: 3,
	},
	[MERGE_TAG.SQUARE_ICON]: {
		title: 'Square icon',
		searchLabel: 'Scorecard | Square icon',
		label: 'Scorecard | Square icon',
		groups: [MERGE_TAG_GROUP.SCORECARD],
		order: 4,
	},
	[MERGE_TAG.CHANGE_EMAIL]: {
		title: 'Change details',
		searchLabel: 'Links | Change details',
		label: 'Change details',
		groups: [MERGE_TAG_GROUP.LINKS],
		order: 1,
	},
	[MERGE_TAG.RESULT_BUTTON]: {
		title: 'Result button',
		searchLabel: 'Links | Result button',
		label: 'Result button',
		groups: [MERGE_TAG_GROUP.LINKS],
		order: 2,
	},
	[MERGE_TAG.REPORT_BUTTON]: {
		title: 'PDF report button',
		searchLabel: 'Links | PDF report button',
		label: 'PDF report button',
		groups: [MERGE_TAG_GROUP.LINKS],
		order: 3,
	},
})

export const MERGE_TAG_GROUPS = Object.freeze({
	[MERGE_TAG_GROUP.QUIZ_ANSWER]: {
		title: 'Quiz answers',
		order: 1,
	},
	[MERGE_TAG_GROUP.LEAD_FORM_ANSWERS]: {
		title: 'Lead form answers',
		order: 2,
	},
	[MERGE_TAG_GROUP.SCORES]: {
		title: 'Scores',
		order: 3,
	},
	[MERGE_TAG_GROUP.LEAD]: {
		title: 'Lead',
		order: 4,
	},
	[MERGE_TAG_GROUP.SCORECARD]: {
		title: 'Scorecard',
		order: 5,
	},
	[MERGE_TAG_GROUP.LINKS]: {
		title: 'Links',
		order: 6,
	},
	[MERGE_TAG_GROUP.OVERALL]: {
		title: 'Overall',
		order: 1000,
	},
})
